module.exports = __webpack_public_path__ + "img/2.10368d14.jpg";